export function ADICIONA_DADOS_INTERNOS({ rootGetters, commit }, payload) {
  return new Promise((resolve) => {
    console.log(payload);
    let user = rootGetters["usuario/USER_DATA"];
    let dados = {
      id_vendedor: user.id,
      id_unidade: user.id_unidade,
      nome_unidade: user.nome_unidade,
      nome_vendedor: user.nome,
      id_produto: payload.id_produto,
      id_plano: payload.id_plano,
      nome_produto: payload.nome_produto,
      nome_plano: payload.nome_plano,
    };

    commit("SET_DADOS_INTERNOS", dados);
    resolve();
  });
}
